// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"b74d7b4c","66":"d5d3a7e3","375":"af0e7230","533":"2fb25cae","565":"30ce491b","595":"0f5d4ce9","597":"2ad77016","615":"59110ff2","635":"39c95a85","682":"ab85ba28"}[chunkId] + ".chunk.js";
};